import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconWeeklyCalendar = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={13}
    fill="none"
    viewBox="0 0 12 13"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#000"
      fillOpacity={0.8}
      d="M8.625 6.5c.188 0 .375.188.375.375v1.5c0 .21-.188.375-.375.375h-5.25A.37.37 0 0 1 3 8.375v-1.5c0-.188.164-.375.375-.375h5.25ZM3.75.5a.57.57 0 0 1 .563.563V2h3.375v-.938c0-.304.234-.562.562-.562a.57.57 0 0 1 .563.563V2h.937c.82 0 1.5.68 1.5 1.5V11c0 .844-.68 1.5-1.5 1.5h-7.5A1.48 1.48 0 0 1 .75 11V3.5c0-.82.656-1.5 1.5-1.5h.938v-.938c0-.304.234-.562.562-.562ZM10.125 5h-8.25v6c0 .21.164.375.375.375h7.5a.385.385 0 0 0 .375-.375V5Z"
    />
  </svg>
));
export default SvgIconWeeklyCalendar;
